import { Form, Input, Typography } from 'antd';
import { Rule } from 'antd/es/form';

import InfoTooltip from 'components/info/info';

interface FormItemInputProps {
	name: string;
	label?: string;
	rules?: Rule[];
	fullWidth?: boolean;
	style?: React.CSSProperties;
	noAutoComplete?: boolean;
}

function FormPassword({ name, label, rules, fullWidth, style, noAutoComplete }: FormItemInputProps) {
	return (
		<>
			{label && <Typography.Text style={{ marginBottom: 5, display: 'block', fontSize: 15 }}>{label}</Typography.Text>}
			<Form.Item name={name} rules={rules} style={{ ...style, maxWidth: fullWidth ? 'unset' : 'var(--inputWidth)' }}>
				<Input.Password autoComplete={noAutoComplete ? 'new-password' : 'off'} />
			</Form.Item>
		</>
	);
}

export default FormPassword;
